import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class PatientMedicationsService extends ClientDataService {
  private PATIENT_MEDICATIONS_OPTIONS_DOC = 'tb_pl_meds'
  private DOSE_UNITS_OPTIONS_DOC = 'tb_nhtsa_doseunit'
  private ROUTE_OPTIONS_DOC = 'tb_nhtsa_medroute'
  private FREQUENCY_OPTIONS_DOC = 'tb_nemsis3_med_frequency'

  async getPatientMedicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_MEDICATIONS_OPTIONS_DOC)
  }

  async getDoseUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DOSE_UNITS_OPTIONS_DOC)
  }

  async getFrequencyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FREQUENCY_OPTIONS_DOC)
  }

  async getRouteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ROUTE_OPTIONS_DOC)
  }
}
